import { CapitalizeNames as capitalize } from 'src/utils/capitalize';
import { TMailFactory } from './types';

/**
 * Mag Group Mail Factory
 *
 * @param {*} lead
 * @return {*}
 */
export const magGroupFactory: TMailFactory = (lead) => {
    const { agent, vehicle, store, name } = lead;

    return {
        subject: `¿Estás listo para experimentar la aventura a otro nivel en tu nuevo ${vehicle.make.name.toUpperCase()}?`,
        message: `Estimado ${capitalize(name)}.

Lo contacta ${capitalize(
            agent?.name
        )}, su embajador de marca en ${vehicle.make.name.toUpperCase()} ${capitalize(
            store.name
        )}. He recibido su solicitud de información para adquirir un ${vehicle.make.name.toUpperCase()} ${capitalize(
            vehicle.model
        )}, adjunto podrá encontrar especificaciones del modelo solicitado.
        
Indíqueme por favor, si desea alguna cotización personalizada a lo que está buscando en este momento, me reitero a sus órdenes, es un placer atenderle.`,
    };
};
